// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Get_ExpenseDistribute } from '../../store/Lookup/lookupSlice';

const useLookupGetExpenseDistribute = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(Get_ExpenseDistribute());
  }, []);

  const { ExpenseDistribute, loading, error } = useSelector(state => state.Lookup);

  return { ExpenseDistribute, loading, error };
};

export default useLookupGetExpenseDistribute;
